import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import InputTextField from "@/Components/Form/InputTextField";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import InputTextarea from "@/Components/Form/TextAreaField";
import { ColumnsToolPanelModule } from "ag-grid-enterprise";
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  label = "",
  title = "",
  jobNo = "",
  reason = "",
  subtitle = "",
  setReason = null,
  inputLabel = "Reason",
  inputPlaceholder = "Enter reason",
  confirmLabel = "Ok",
  cancelLabel = "Cancel",
  Note = "",
  loading = false, // 👈 added
  loadingText,
  sx = {},
  props,
}) => {
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 10,
          py: 4,
        }}
      >
        {label}
        <IconButton
          onClick={onClose}
          sx={{
            fontSize: "35px",
            color: "var(--brand-950)",
            "&:hover": {
              backgroundColor: "transparent",
              color: "var(--brand-950)",
            },
          }}
        >
          &times;
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent
        sx={{
          paddingX: 3,
          paddingY: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {title && <Typography variant="bodyBase">{title}</Typography>}

        {subtitle && (
          <Typography variant="bodyBase">
            {subtitle} <strong>{jobNo}</strong>
          </Typography>
        )}

        {Note && <Typography variant="bodyBase">{Note}</Typography>}

        {typeof setReason === "function" && (
          <InputTextarea
            actionText={inputLabel}
            fullWidth
            placeholder={inputPlaceholder}
            multiline
            minRows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{
              borderRadius: "10px",
              "& .MuiInputBase-root": {
                height: 100,
                alignItems: "flex-start",
                mb: 1,
              },
            }}
          />
        )}
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: "space-between", px: 3 }}>
        <OutLinedButton
          label={cancelLabel}
          onClick={onClose}
          variant="outlined"
          sx={{
            width: 200,
            height: 40,
            borderRadius: 2,

            color: "var(--brand-600)",
            borderColor: "var(--brand-600)",
            "&:hover": {
              backgroundColor: "transparent",
              borderColor: "var(--brand-900)",
            },
          }}
        />
        <BlackButton
          label={confirmLabel}
          loadingText={loadingText}
          onClick={onConfirm}
          disabled={loading}
          loading={loading} // 👈 spinner + color handled inside BlackButton
          variant="outlined"
          sx={{
            width: 200,
            height: 40,
            borderRadius: 2,
            mt: 1,
            color:loading ? "var(--gray-0)":"var(--gray-0)",
            borderColor: "var(--brand-600)",
            backgroundColor: loading ? "var(--gray-600)" : "var(--brand-600)", // 👈 change color on loading
            "&:hover": {
              backgroundColor: loading ? "var(--gray-500)" : "var(--brand-600)",
              borderColor: "var(--brand-900)",
            },
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
